import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import NowUiKit from "./plugins/now-ui-kit";
import { helpers, cartManager, enumHelper, subdomain } from "@/utilities";
import "./utilities/vee-validate-rules";
import { mapActions, mapGetters, mapState } from "vuex";
import VueGtm from '@gtm-support/vue2-gtm';
import i18n from './i18n';
import onMesssageMixin from '@/mixins/onMesssageMixin'
//import socialLogin from '@/components/SocialLogin'
//import SocialLogout from '@/components/SocialLogout'
import './plugins/smart-app-banner/index.css'
import {
  isAndroid,
} from "mobile-device-detect";
Vue.config.productionTip = false;
Vue.use(NowUiKit);
Vue.use(VueGtm, {
  id: process.env.VUE_APP_GTM, // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryPararms: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}]
  defer: false, // defaults to false. Script can be set to `defer` to increase page-load-time at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible)
  enabled: false, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  //debug: true, // Whether or not display console logs debugs (optional)
  loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
  vueRouter: router, // Pass the router instance to automatically sync with router (optional)
  trackOnNextTick: false, // Whether or not call trackView in Vue.nextTick
});
//Vue.component(socialLogin.name, socialLogin)
//Vue.component(SocialLogout.name, SocialLogout)

async function InitApp() {
  
  return Promise.resolve();
}
export default InitApp().then(() => {
  new Vue({
    router,
    store,
    i18n,
    render: (h) => h(App),
    mixins:[onMesssageMixin],
    computed: {
      ...mapState({
        locations: (state) => state.locations,
        code : (state) => state.currentLanguage,
        user: (state) => state.auth.user,
        business:(state)=>state.business
      }),
      ...mapGetters(['getTrackingStatus', 'isAuthenticated', 'getOneSignalUserId'])
    },
    methods: {
      ...mapActions([
        "fetchTheme",
        "fetchLocationsByPostCode",
        "getPublicDocsRequest",
        "saveTrackingStatus",
        "saveApplePayAvailibility" ,
        "saveGooglePayAvailibility" ,
        "saveChannel",
        "saveOneSignalUserId",
        "saveOneSignalPlayerId",
        "fetchAuthUser"
      ]),
      //---- check the position Object before getting the website data
      fetchThemeConfiguration() {       
        this.fetchTheme()
          .then((response) => {
            if (response && response.error) {
              
              this.$mount("#app");
              helpers.showErrorMessageAlert(
                helpers.getMessageFromAPIError(response)
              );
              return;
            }
            // fetch the autenticated user
            if(this.isAuthenticated){
              this.fetchAuthUser()
            }  
            let cart = cartManager.getCart();
            if (
              this.locations.length == 1 &&
              cart &&
              cart.orderType == enumHelper.orderType.Delivery &&
              cart.postCode
            ) {
              this.fetchLocationsByPostCode(cart.postCode).then((response) => {
                if (response && response.error) {
                  return;
                }
                this.$store.dispatch(
                  "storeSelectedLocation",
                  response.data.data[0]
                );
                
                this.$mount("#app");
                if (router.currentRoute.name == "notExist") router.push("/");
              }).catch(()=>{
                this.$mount("#app");
                if (router.currentRoute.name == "notExist") router.push("/");
              });
            } else {
              this.$mount("#app");
              if (router.currentRoute.name == "notExist") router.push("/");
            }
          })
          .catch(() => {
            this.$mount("#app");
            router.push("/not-exist");
          })
        this.getPublicDocsRequest();  
      },
      enableDisableTracking(enabled){
        this.$gtm.enable(enabled == true);
      }
    },
    watch:{
      getTrackingStatus(newVal){
        this.enableDisableTracking(newVal)
      }
    },
    created() {
      this.fetchThemeConfiguration();
     
      // The configuration of the plugin can be changed at any time.
      // Just call the setOptions method and pass the object with the settings to it.
      this.$storage.setOptions({
        prefix: subdomain.get() + "_",
        driver: "local",
        ttl: helpers.getCookieTimeExpiration(), //60 * 60 * 24 * 1000
      });

      if(!helpers.IsWebView() ) { //|| !isIOS
        this.saveTrackingStatus(true)
      }
      //--- this will be used only if it's w webView
      if(helpers.IsWebView()){

        isAndroid ? document.addEventListener("message", this.messageReceived, false) :
        window.addEventListener("message", this.messageReceived, false);

        if(this.isAuthenticated && this.user &&  !this.getOneSignalUserId){
          this.sendMessage({userId:this.user.id})
        }
      }
    },
    mounted(){      
      this.enableDisableTracking(this.getTrackingStatus) //-- DON'T FORGET TO set getTrackingStatus to null when activing tracking transparency
    }
  });
});
